export default {
  apiCreateComplaint(data) {
    return this.request(this.api().CREATE_COMPLAINT, data)
      .exec()
      .log()
      .mapresults((response) => {
        return response.data;
      })
      .get();
  },
  apiGetAllComplaints(data) {
    return this.request(this.api().GET_ALL_COMPLAINTS, data)
      .exec()
      .log()
      .mapresults((response) => {
        return {
          data: response?.data,
          total: response?.count,
        };
      })
      .get();
  },
  apiComplaintAssignBulk(data) {
    return this.request(this.api().COMPLAINT_ASSIGN_BULK, data)
      .exec()
      .log()
      .get();
  },
  apiGetComplaintCards(data) {
    return this.request(this.api().GET_COMPLAINT_CARDS, data)
      .exec()
      .log()
      .get();
  },
  apiGetComplaintById(urldata = {}) {
    return this.request(this.api().GET_COMPLAINT_BY_ID)
      .urltransform(urldata)
      .exec()
      .log()
      .mapresults((response) => {
        return response;
      })
      .get();
  },
  apiUpdateComplaintById(data, urldata = {}) {
    return this.request(this.api().UPDATE_COMPLAINT_BY_ID, data)
      .urltransform(urldata).exec().log().get();
  },
};
